<template lang="pug">
aside.pending-requests
    h3.heading Pending Requests
        img(:src="UndoIcon" :class="{loading: requestStore.loading}" @click="requestStore.reloadRequests()")
    ul.scroll-y(v-if="signedRequests.length > 0")
        li(
            v-for="request in signedRequests"
            :key="`req-${request.dogId}`"
        )
            .pending-request(:class="{active: selectedRequest === request.$id}" @click="selectedRequest = request.$id")
                .req-val.event-type(:style="`background-color: ${getEventColor(request)}`") {{ Events.EventTypeMap[request.eventType] }}{{ 'trainingType' in request ? `: ${request.trainingType}` : null }}
                .req-val.dog-size(:style="`background-color: ${getSizeColor(dogStore.dogs[request.dogId])}`") {{ dogStore.dogs[request.dogId]?.size || "Unknown" }}
                .req-val.start-date {{ new Date(request.startTime).toLocaleDateString() }}
                //-UpdateRequest.request-modal(v-if="selectedRequest === request.$id" :id="request.$id" @close="selectedRequest = null" @click.stop)

        UpdateRequest.request-modal(v-if="selectedRequest" :id="selectedRequest" @close="selectedRequest = null" @click.stop)
    template(v-else) 
        p All caught up
        p(v-if="requestStore.pendingRequests.length - signedRequests.length > 0") 
            | There {{ requestStore.pendingRequests.length - signedRequests.length > 1 ? 'are' : 'is' }} {{ requestStore.pendingRequests.length - signedRequests.length }} unsigned 
            |  {{ requestStore.pendingRequests.length - signedRequests.length > 1 ? 'requests' : 'request' }}
</template>

<script setup lang="ts">
import { useDogspace } from '@/store/dogspaces';
import { useScheduleRequests } from '@/store/useScheduleRequests';
import { Dogspaces, Events, ScheduleRequest } from '@busy-human/k9-library';
import { computed, onMounted, ref } from 'vue';
import UpdateRequest from './update-request.vue';
import UndoIcon from '@/resources/icons/icons8_undo.png';

const requestStore = useScheduleRequests();
const dogStore = useDogspace();

const selectedRequest = ref<string | null>(null);

const signedRequests = computed(() => 
	requestStore.pendingRequests.filter((r) => !(r.eventType === Events.EventType.Training && r.agreementId && !r.agreementSigned))
);


function getEventColor(event: ScheduleRequest.Model) {
	if(event.eventType === Events.EventType.Training) {
		return "#ADE6FF";
	} else if (event.eventType === Events.EventType.Boarding) {
		return "#DBFFBF";
	} else if (event.eventType === Events.EventType.PickupDropoff) {
		return "#D7D7D7";
	}
}

function getSizeColor(dog: Dogspaces.Model) {
	if(dog?.size === 'small') return "#A4E4FF";
	else if(dog?.size === 'medium') return "#AC97FF";
	else if(dog?.size === 'large') return "#E497FF";
	else if(dog?.size === "x-large") return "#FF9399";
	else return "#D7D7D7";
}

onMounted (() => {
    console.log("REQUESTS:", requestStore);
});
</script>

<style lang="scss">
aside.pending-requests {
    position:relative;
    box-sizing: border-box;
    height: 100%;
    max-height: 100%;

    @keyframes spin {
            from { transform: rotate(0deg);}
            to { transform: rotate(360deg);}
        }

        ul {
        height: 100%;
        max-height: 100%;
        padding-right: 0.5rem;
        list-style: none;
    }

    h3.heading {
        display: flex;
        align-items: center;

        img{
            place-self: flex-end;
            margin-left: .5em;
        }

        img:hover {
            cursor: pointer;
        }

        img.loading {
            animation: spin 1s cubic-bezier(0.450, 0.055, 0.620, 0.885) infinite reverse;
        }
    }

    .request-modal {
        position: absolute;
        top:0;
        left: 100%;
        background: $color-red;
    }

    .pending-request {
        position: relative;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, auto);
        gap: .24rem;
        padding: .5rem;
        margin-bottom: 0.5rem;
        border: 1px solid $color-black;
        box-shadow: 2px 2px 0 $color-black;

        &:hover {
            cursor: pointer;
            outline: 1px dashed $color-red;
        }

        &.active {
            outline: 1px dashed $color-red;
        }
    }

    .req-val {
        box-sizing: border-box;
        padding-left: .1rem;
        text-transform: capitalize;
        border-radius: .25rem;
    }

    .event-type {
        grid-column: 1 / -1;
        white-space: nowrap;
    }

    .dog-size {
        background: $color-status-valid;
        box-shadow: 0 2px 0 $color-black;
    }

    .start-date {
        place-self: end;
    }
}
</style>